import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { EventsRouter } from '../../../events/types';
import { modules } from '../../modules';

@injectable()
export class EventsRouterService implements EventsRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToDetail(id: string) {
    this.history.push(`/${this.role.get()}/${modules.events.basename}/${id}`);
  }

  goToDetailOnOtherSide(id: string) {
    this.history.push(
      `/${this.role.get() === 'employee' ? 'company' : 'employee'}/${
        modules.events.basename
      }/${id}`,
    );
  }

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(`/${this.role.get()}/${modules.events.basename}`);
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.events.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToPaperList(query?: string) {
    if (!query || query === '?') {
      this.history.push(
        `/${this.role.get()}/${modules.events.basename}/${
          modules.paper.basename
        }`,
      );
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.events.basename}/${
        modules.paper.basename
      }`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToCreateType() {
    this.history.push(
      `/${this.role.get()}/${modules.events.basename}/create-type`,
    );
  }

  goToCreate(query: string) {
    this.history.push({
      pathname: `/${this.role.get()}/${modules.events.basename}/create`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToCreateBatch({
    companyId,
    eventTypeId,
    employeeId,
    parentEventId,
  }: {
    companyId: string;
    eventTypeId: string;
    employeeId?: string;
    parentEventId?: string;
  }) {
    let searchString = `?companyId=${companyId}&eventTypeId=${eventTypeId}`;

    if (employeeId) {
      searchString += `&employeeId=${employeeId}`;
    }

    if (parentEventId) {
      searchString += `&parentEventId=${parentEventId}`;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.events.basename}/create-batch`,
      search: searchString,
    });
  }

  goBack(prevState: { pathname: string; search: string }) {
    this.history.push(prevState);
  }
}
